import {Note} from '@/types/note'
import apiClient from '@/utils/axios'
import {apiEndPoints} from '@/utils/constant'
import {AxiosResponse} from 'axios'


const {SOLICITATION_URL, SOLICITATION_NOTE_URL} = apiEndPoints

interface SolicitationNoteService {
  get(solicitationId: string): Promise<AxiosResponse<Note[]>>
  getById(solicitationId: string, id: string): Promise<AxiosResponse<Note>>
  create(solicitationId: string, payload: Note): Promise<AxiosResponse<Note>>
  update(solicitationId: string, id: string, question: Note): Promise<AxiosResponse<Note>>
  delete(solicitationId: string, id: string): Promise<AxiosResponse<string>>
}

const solicitationNote: SolicitationNoteService = {
  async get(solicitationId) {
    const response = await apiClient.get(`${SOLICITATION_URL}/${solicitationId}/${SOLICITATION_NOTE_URL}`)
    return response
  },

  async create(solicitationId, payload) {
    const response = await apiClient.post(`${SOLICITATION_URL}/${solicitationId}/${SOLICITATION_NOTE_URL}`, payload)
    return response
  },

  async getById(solicitationId, id) {
    const response = await apiClient.get(`${SOLICITATION_URL}/${solicitationId}/${SOLICITATION_NOTE_URL}/${id}`)
    return response
  },

  async update(solicitationId, id, payload) {
    const response = await apiClient.
    put(`${SOLICITATION_URL}/${solicitationId}/${SOLICITATION_NOTE_URL}/${id}`, payload)
    return response
  },

  async delete(solicitationId, id) {
    const response = await apiClient.delete(`${SOLICITATION_URL}/${solicitationId}/${SOLICITATION_NOTE_URL}/${id}`)
    return response
  },
}

export {solicitationNote}
